// extracted by mini-css-extract-plugin
export var apiV2ContractTable = "api-v2-contract-table_lShmDch4Cjmzlh1u9S1K";